module.exports = {
  title: `taeyunahn.com`,
  description: `안태윤의 개발 일기`,
  aboutSeo: {
    title: `안태윤 | 경력·연구·프로젝트`,
    description: `안태윤의 2026년 9월 CV. 소프트웨어 개발 경력, AI·로보틱스 기술, 연구 논문, 프로젝트와 수상 이력을 소개합니다.`,
    language: `ko`,
  },
  language: `ko`, // `ko`, `en` => currently support versions for Korean and English
  siteUrl: `https://TaeYunAhn.github.io`,
  ogImage: `/og-image.png`, // Path to your in the 'static' folder
  comments: {
    utterances: {
      repo: `https://github.com/TaeYunAhn/TaeYunAhn.github.io`,
    },
  },
  ga: '0', // Google Analytics Tracking ID
  author: {
    name: '안태윤',
    bio: {
      role: '소프트웨어 엔지니어',
      description: ['최적화 알고리즘 구현 경험', '웹 풀스택 개발', '실전 문제 해결력'],
      thumbnail: 'sample.png',
    },
    social: {
      github: '',
      linkedIn: '',
      email: 'tahn@jbnu.ac.kr',
    },
  },
};
